import { createIcon } from '@chakra-ui/react';

export const DateRangeIcon = createIcon({
  displayName: 'DateRangeIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
        <g clipPath="url(#clip0_2378_48253)">
          <path
            d="M5.25 6.41797H4.08333V7.58464H5.25V6.41797ZM7.58333 6.41797H6.41667V7.58464H7.58333V6.41797ZM9.91667 6.41797H8.75V7.58464H9.91667V6.41797ZM11.0833 2.33464H10.5V1.16797H9.33333V2.33464H4.66667V1.16797H3.5V2.33464H2.91667C2.26917 2.33464 1.75583 2.85964 1.75583 3.5013L1.75 11.668C1.75 12.3096 2.26917 12.8346 2.91667 12.8346H11.0833C11.725 12.8346 12.25 12.3096 12.25 11.668V3.5013C12.25 2.85964 11.725 2.33464 11.0833 2.33464ZM11.0833 11.668H2.91667V5.2513H11.0833V11.668Z"
            fill="#6E6789"
          />
        </g>
        <defs>
          <clipPath id="clip0_2378_48253">
            <rect width="14" height="14" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  ),
});
